module.exports = __webpack_public_path__ + "static/media/non_ulip.61e0ebdb.mp3";